import { styled } from 'styled-components';

export const StyledCartPage = styled('div')`
  .container {
    padding: 0 20px 20px 20px;
    background-color: ${(props) => props.theme.whiteBackground};
    border-radius: 15px;

    .ant-divider {
      margin: 12px 0 0 0;
    }
  }

  .cart-page-title {
    display: block;
    font-family: ${(props) => props.theme.fontText};

    h1 {
      font-size: 2.625em;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-top: 0.32em;
      padding-bottom: 1.28em;
      font-weight: 500;
    }

    &.mobile {
      color: ${(props) => props.theme.black};
      display: none;
      h1 {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .back-button {
    display: none;
  }

  @media only screen and (max-width: 576px) {
    .container {
      padding-bottom: 0;

      .ant-divider {
        display: none;
      }
    }

    .back-button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 37px 0px 17px 20px;
      border-bottom: 1px solid ${(props) => props.theme.lightGrayBorder};
      font-size: 14px;
      font-weight: 400;
      div {
        display: flex;
        height: 17px;
        width: 17px;
      }
    }

    div[class*='ant-steps'] {
      display: none;
    }

    .cart-page-title {
      display: none;
      font-size: 18px;

      h1 {
        margin: 10px 0;
      }

      &.mobile {
        display: block;
        margin-bottom: 10px;

        h1 {
          margin: 0;
          padding: 20px 0;
        }
      }
    }
  }

  @media only screen and (max-width: 1200px) {
    .cart-order-summary-wrapper {
      padding: 0 !important;
    }
  }
`;
